import { useState } from "react";
import emailjs from '@emailjs/browser';
import { useRef } from "react";

export const FeedbackForm = () => {
  const [inputValue1, setInputValue1] = useState('');
  const [inputValue2, setInputValue2] = useState('');
  const [inputValue3, setInputValue3] = useState('');
  
  const form = useRef();
  
  const handleSubmit = (event) => {
    event.preventDefault();

    emailjs.sendForm('service_xpq7que', 'template_y3yojlu', form.current, 'LKOAmjKUlwjL7D2M6')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  
    
    setInputValue1('');
    setInputValue2('');
    setInputValue3('');
    
  }
  return (
    <div className="form__container">
      <h3>If you have any questions, contact support</h3>
      <form className="form" onSubmit={handleSubmit} ref={form}>
        <input
          type="text"
          className="input"
          placeholder="Name"
          name="user_name"
          value={inputValue1}
          onChange={(event) => { setInputValue1(event.target.value) }}
        >
        </input>
        <input
          type="email"
          className="input"
          placeholder="Email"
          name="user_email"
          value={inputValue2}
          onChange={(event) => { setInputValue2(event.target.value) }}
          required
        >
        </input>
        <textarea
          className="input textarea"
          placeholder="Message"
          name="message"
          value={inputValue3}
          onChange={(event) => { setInputValue3(event.target.value) }}
        >
        </textarea>
        <button className="submit-btn">Submit</button>
      </form>
    </div>
  )
}